The job category for the given `id`.

This query accepts browser tokens that include the `query:ontologies` or `query:enhanced-job-posting` scope.
